import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';

export function PopHeroEyebrow(): JSX.Element {
  const t = useTranslations();

  return (
    <Motion
      animate={{ opacity: 1 }}
      className="mb-3 inline-block rounded-lg bg-slate-200 px-3 py-2 text-sandstone-200"
      data-cy="pop_hero_eyebrow"
      initial={{ opacity: 0 }}
      transition={{ duration: 1, type: 'tween', delay: 1.5 }}
    >
      <TypographyV3
        className="whitespace-nowrap uppercase tracking-wider"
        color="inherit"
        variant="eyebrow-small"
        weight="bold"
      >
        {t('gen3_special_pricing')}
      </TypographyV3>
    </Motion>
  );
}
